// extracted by mini-css-extract-plugin
module.exports = {"button":"cg","primary":"ch","mobile":"ci","secondary":"cj"};